import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';
import type { SwitchProps, TextProps } from 'react-native-paper';
import { HelperText, Switch, Text } from 'react-native-paper';

import { isEmptyOrNull } from '@/shared/utils/string';

const styles = StyleSheet.create({
  container: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  label: { flex: 1 }
});

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  label: string;
  labelVariant?: TextProps<string>['variant'];
  helperText?: string;
  style?: ViewStyle;
} & SwitchProps;

export const FormSwitch = <T extends FieldValues>({
  name,
  control,
  label,
  labelVariant = 'titleMedium',
  helperText,
  style,
  ...rest
}: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field: { value, onChange }, fieldState: { error } }) => (
      <View>
        <View style={[styles.container, style]}>
          <Text
            variant={labelVariant}
            numberOfLines={2}
            ellipsizeMode="tail"
            style={styles.label}
          >
            {label}
          </Text>
          <Switch {...rest} value={value} onValueChange={onChange} />
        </View>

        {isEmptyOrNull(error?.message) ? (
          !isEmptyOrNull(helperText) && (
            <HelperText type="info">{helperText}</HelperText>
          )
        ) : (
          <HelperText type="error">{error?.message}</HelperText>
        )}
      </View>
    )}
  />
);
